import { Component, OnInit,Input,Output,EventEmitter} from '@angular/core';
import{QuestionManagementService} from '../../../Services/question-management/question-management.service';
import{SessionService} from '../../../Services/session.service';
import { ToastrService } from "ngx-toastr";
@Component({
  selector: 'app-question-preview-appeanrance',
  templateUrl: './question-preview-appeanrance.component.html',
  styleUrls: ['./question-preview-appeanrance.component.css']
})

export class QuestionPreviewAppeanranceComponent implements OnInit  {
  @Input() subjectById:any;
  @Input() selectedQuestionById:any;
  @Output() close : EventEmitter<any> = new EventEmitter<any>();
  QuestionNo:any;
  values:any[]=[];
  constructor(public toastr:ToastrService,public service:QuestionManagementService,public session:SessionService) { }

  ngOnInit(): void {
    this.getBreadcrumbDetails();
    this.getExamAgenecy();
    this.QuestionNo=this.selectedQuestionById[0].Question_ID;
    this.getQuestionPreviewAppearance({QuestionID:this.QuestionNo});
    //this.addvalue();
  }




  Breadcrumblist:any;
  getBreadcrumbDetails() {
    this.service.getBreadcrumbDetails({ 'ID': this.subjectById.Subject_Id }).subscribe((i: any) => {
      this.Breadcrumblist = i;
    // }).catch((e: any) => {
    //   this.subjectById = null;
    // }
    // )
  }, error => {  console.log(error) }
  );
  }

  getQuestionAppearancelist:any;
  deletedQuestionlist:any[] = [];;
  response:any;
  getQuestionPreviewAppearance(data:any) {
    this.service.GetQuestionAppearance(data).subscribe((i: any) => {
      this.response = i;
      this.getQuestionAppearancelist=this.response.data;
      console.log(this.getQuestionAppearancelist);
      if(this.getQuestionAppearancelist!=null){
        if(this.getQuestionAppearancelist.length==0){
          this.deletedQuestionlist=[];
         this.addvalue();
        }
        else{
          this.getQuestionAppearancelist.map((obj: {
            DeleteInd: string;
            EditFlag:boolean;
    }) => {
            obj.EditFlag=false;
            obj.DeleteInd='N';
            return obj;
            })
            this.deletedQuestionlist=[];
        }
        this.booksByStoreID = this.getQuestionAppearancelist.filter(
          () => this.getQuestionAppearancelist.DeleteInd === 'N');

          console.log(this.booksByStoreID,'booksByStoreID');
      }
  }, 
  error => {  console.log(error) }
  );
  }


  
 getexamagency:any;
 getExamAgenecy()
 {
   this.service.GetCodeExam({'Tablename':"EXAM_AGENCY"}).subscribe((i:any)=>{
     this.getexamagency=i;
     console.log(this.getexamagency,'getexamagency');
   // }).catch((e:any)=>{
   //   this.getcodes=null;
   // });
 }, (error:any) => { console.log(error) }
 );
 }

 getexammaster:any;
 getExamMaster(data:any,index:number)
 {
   this.service.GetCodeExam({'Tablename':data}).subscribe((i:any)=>{
     this.getexammaster=i;
     this.getQuestionAppearancelist[index].Exam_Master=this.getexammaster;
     console.log(this.getexammaster,'getexammaster');
   // }).catch((e:any)=>{
   //   this.getcodes=null;
   // });
 }, (error:any) => { console.log(error) }
 );
 }

 getexaminstance:any;
 getExamInstance(data:any,index:number)
 {
   this.service.GetCodeExam({'Tablename':data}).subscribe((i:any)=>{
     this.getexaminstance=i;
     this.getQuestionAppearancelist[index].Exam_Instance=this.getexaminstance;
     console.log(this.getexaminstance,'getexaminstance');
   // }).catch((e:any)=>{
   //   this.getcodes=null;
   // });
 }, (error:any) => { console.log(error) }
 );
 }

 value:any;
 selectagency(event:string,index:number){
  this.getQuestionAppearancelist[index].Exam_Agency_ID=event;
  console.log(this.getQuestionAppearancelist);
  this.value='EXAM_MASTER@'+event;
  console.log(this.value,'EXAM_MASTER')
  this.getExamMaster(this.value,index);

}
selectexam1(){
console.log('test');
}
 instancevalue:any;
 selectmaster(event:string,index:number){
  this.getQuestionAppearancelist[index].Exam_Master_ID=event;
  console.log(this.getQuestionAppearancelist);
  this.instancevalue='EXAM_INSTANCE@'+event;
  console.log(this.instancevalue,'EXAM_INSTANCE')
  this.getExamInstance(this.instancevalue,index);
}

yearvalue:any;
selectinstance(event:string,index:number){
  // if(!this.getQuestionAppearancelist[index].EditFlag){
    this.getQuestionAppearancelist[index].Exam_Instance_ID=event;
  // }
 
 this.ValidateExamCategory(this.getQuestionAppearancelist[index].Exam_Agency_ID,this.getQuestionAppearancelist[index].Exam_Master_ID,this.getQuestionAppearancelist[index].Exam_Instance_ID,index)
 console.log(this.getQuestionAppearancelist);
}

// values: any;
// addvalue() {
//   this.values.push({ Code: "",PowerUserSubjectId:0});
//   console.log(this.values)
// }




addvalue() {
  let list: any = {};
  list["Question_Previous_Appearance_ID"] = null,
  list["Question_ID"] = this.QuestionNo,
  list["Exam_Agency_ID"] = "",
  list["Exam_Agency_Name"] ="",
  list["Exam_Master_ID"] =null,
  list["Exam_Name"] ="",
  list["Exam_Instance_ID"] =null, 
  list["Exam_Instance_Name"] ="",
  list["Scheduled_Exam_Date"] ="",
  list["Actual_Exam_Date"] ="",
  list["Exam_Instance"]=null,
  list["Exam_Master"]=null,
  list["EditFlag"]=true,
  list["DeleteInd"]='N',
  this.getQuestionAppearancelist.push(list);
  console.log(this.getQuestionAppearancelist)
  this.Clear();
}

editQuestion:boolean=false;
  Editvalue(index:number){
  this.getQuestionAppearancelist[index].EditFlag=true;
  }
  deleteflag:boolean=false;
  removevalue(i:number) {
    if(!this.getQuestionAppearancelist[i].Question_Previous_Appearance_ID){
      this.getQuestionAppearancelist.splice(i, 1);
      this.Clear();
      if(this.getQuestionAppearancelist.length==0){
        this.addvalue();
      }
    }
    else{
      this.getQuestionAppearancelist[i].DeleteInd='Y';
      // let UDTdeletedQuestionlist: any[] = [];;
      // UDTdeletedQuestionlist.push(this.getQuestionAppearancelist[i]);
      this.deletedQuestionlist.push(this.getQuestionAppearancelist[i]);
      this.getQuestionAppearancelist.splice(i, 1);
      if(this.getQuestionAppearancelist.length==0){
        this.addvalue();
      }
      
    }
  }
  check:boolean;
  insertresponse:any;
  save(){
  let UDTQuestionPreviousAppearancelist: any[] = [];

  //validate initial iteration
  if(this.deletedQuestionlist.length>0){
    if(this.getQuestionAppearancelist.length==1){
     for (let i=0;i<this.getQuestionAppearancelist.length;i++) {
      if(!this.getQuestionAppearancelist[i].Question_ID||!this.getQuestionAppearancelist[i].Exam_Instance_ID||!this.getQuestionAppearancelist[i].DeleteInd)
      {
         this.getQuestionAppearancelist.splice(i,1);
      }
    }
    }
  }
  //merge the deleted list with main list
  if(this.deletedQuestionlist){
    for (let item of this.deletedQuestionlist) {
    this.getQuestionAppearancelist.unshift(item);
    }
  }
  this.getQuestionAppearancelist.forEach((element: { Question_Previous_Appearance_ID: any; Question_ID: any; Exam_Instance_ID: any; DeleteInd: any; }) => {
    let tempListlet: any = {};
    tempListlet["Question_Previous_AppearanceId"] = element.Question_Previous_Appearance_ID,
    tempListlet["Question_ID"] = element.Question_ID,
    tempListlet["Exam_Instance_ID"] = element.Exam_Instance_ID,
    tempListlet["DeleteInd"] =element.DeleteInd
    UDTQuestionPreviousAppearancelist.push(tempListlet);
  });
  if(UDTQuestionPreviousAppearancelist.length>0){
  this.check=false;
      for (let item of UDTQuestionPreviousAppearancelist) {
      if(!item.Question_ID||!item.Exam_Instance_ID||!item.DeleteInd)
      {
        this.check=true;
        this.getQuestionAppearancelist.splice(0, this.deletedQuestionlist.length);
        break;
      }
    }
    if(!this.check){
      let tempList={
        
        UDTQuestionPreviousAppearance:UDTQuestionPreviousAppearancelist,
      }
      this.service.InsertOrUpdateQuestionAppearance(tempList).subscribe(
     
        res => {
          console.log(res);
          this.insertresponse=res;
          if(this.insertresponse.Message=='Success'){
            this.toastr.success('Success!');
            //this.getExamAgenecy();
            this.QuestionNo=this.selectedQuestionById[0].Question_ID;
            this.getQuestionPreviewAppearance({QuestionID:this.QuestionNo});
            this.Clear();
            console.log(res)
          }
          else{
            this.toastr.error(this.insertresponse.Message);
          }
          
        },
        error => {
         this.toastr.error('ERROR!',this.insertresponse.Message);
        }
      )
    }
    else{
      this.toastr.error("Please choose all value");
    }
  }
  else{
    this.toastr.error("No data to Save");
  }
}
Cancel(){
  this.close.emit(1);
}
Clear(){
  this.getexaminstance=null;
  this.getexammaster=null;
  this.deleteflag=false;

}
valuecount:number;
checkAdult(getQuestionAppearancelist:any) {
  this.valuecount = this.getQuestionAppearancelist.filter(
    (    getQuestionAppearancelist: { DeleteInd: string; }) => getQuestionAppearancelist.DeleteInd === 'N').length();
  return this.valuecount;
}
validate(index: any): boolean {
 
  let count=-1;
  for(let i=0;i<this.getQuestionAppearancelist.length;i++){
    if(this.getQuestionAppearancelist[i].DeleteInd=='N'){
      count++;
    }
    else{
      if(!this.getQuestionAppearancelist[this.getQuestionAppearancelist.length-1].Question_Previous_Appearance_ID){
        count++;
       }
    }

     
    
  }
 
  if(index==count){
    return true;
  }
  else{
    return false;
  }
  }
  booksByStoreID:any;
  compare:any;
  validate1(index:number):boolean{
   
    this.booksByStoreID = this.getQuestionAppearancelist.filter(
      (      getQuestionAppearancelist: { DeleteInd: string; }) => getQuestionAppearancelist.DeleteInd ==='N');
      console.log(this.booksByStoreID.length,'booksByStoreID')

      // if(index>this.booksByStoreID.length){
      //   index=(index-this.booksByStoreID.length);
      // }

    if((this.booksByStoreID.length-1)==index){
      return true
    }
    else{
      return false
    }
  }

  restrictexam:boolean=false;
  ValidateExamCategory(Examagency:number,Exammaster:number,Examinstance:number,index:number) {
//     this.getQuestionUsagelist.forEach( (array1Ttem: {
//       DeleteInd: string; Exam_Category_Type_Code: any; 
// }) => {
//       this.getcategory.forEach( (array2Item: {
//         Code: any; Exam_Category_Type_Code: any; DeleteInd: string; 
// }) => {
//          if((array1Ttem.Exam_Category_Type_Code == array2Item.Code)&&(array1Ttem.DeleteInd=='N')){
//           this.getcategory.splice(array2Item, 1);
//         }       
//       })
//     })
    this.restrictexam=false;

    // let i = this.getQuestionAppearancelist.length - 1; i >= 0; i--

    for(let i = 0; i <this.getQuestionAppearancelist.length; i++){
      if(i!=index){
      if((this.getQuestionAppearancelist[i].Exam_Agency_ID==Number(Examagency))&&(this.getQuestionAppearancelist[i].Exam_Master_ID==Number(Exammaster))&&(this.getQuestionAppearancelist[i].Exam_Instance_ID==Number(Examinstance)))
      {
        this.restrictexam=true;
        break;
      }
      }
    }




    //   for (let item of this.getQuestionAppearancelist) {
    //   if((item.Exam_Agency_ID==Number(Examagency))&&(item.Exam_Master_ID==Number(Exammaster))&&(item.Exam_Instance_ID==Number(Examinstance)))
    //   {
    //     this.restrictexam=true;
    //     break;
    //   }
    // }
    if(!this.restrictexam){
      this.getQuestionAppearancelist[index].Exam_Instance_ID=Examinstance;
    }
    else{
      this.getQuestionAppearancelist[index].Exam_Instance_ID=Examinstance;
      this.Duplicatealertpopup(index);
      //this.getCategory();
    }
}

clearform(){
    
  
  this.getQuestionAppearancelist[this.Indexvalue].Exam_Instance_ID="";
   
   this.Duplicatealertpopup(1);
  
  
 }

 alertflag:boolean
Indexvalue:any
Duplicatealertpopup(index:any){
this.Indexvalue=index;
this.alertflag=!this.alertflag;
}
  

}
